import { MimaToastUtil } from '../../components';
import { CreateDeduction } from '../../pages';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import * as yup from 'yup';
import { PayrollController } from '../../controllers';

const CreateDeductionContainer = ({ closeModal }) => {
	const [loading, setLoading] = useState(false);

	const validationSchema = () => {
		return yup.object({
			name: yup.string().required('name is required'),
			value: yup.number().min(1).required('Value is required'),
			type: yup.string().required('Type is required'),
		});
	};

	const onSubmit = async payload => {
		setLoading(true);
		const { status, errorMessage } = await PayrollController.createDeduction(
			payload
		);

		if (status === constant.Success) {
			setLoading(false);
			return MimaToastUtil.success({
				message: constant.Success,
			});
		}
		setLoading(false);
		 return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	return (
		<CreateDeduction
			onSubmit={onSubmit}
			closeModal={closeModal}
			loading={loading}
			validationSchema={validationSchema}
		/>
	);
};

export default CreateDeductionContainer;
